module.exports = __webpack_public_path__ + "static/monzo@2x-b27970b3c65c853fa9764fbef899d5ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/monzo@2x.png
// module id = 2693
// module chunks = 157636680307020